import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StructureArrow } from '../../../../MyTeamBackofficeStyled';
import { getRootTeamMember } from '../../../../myTeamBackOffice.actions';

import { Icon, IconStructureNavArrow } from '../../../../../../styles/Icons';
import { color } from '../../../../../../styles/GlobalStyles';
import { StructureType } from '../../../../myTeamBackOffice.constants';

export const GoRightDownArrowButton = () => {
  const dispatch = useDispatch();
  const { rootTeamMember } = useSelector((store) => store.myTeamBackoffice);

  const isRightArrowDownEnabled = rootTeamMember?.rightChildUser?.id;

  const goRighttDown = () => {
    if (isRightArrowDownEnabled) {
      dispatch(
        getRootTeamMember(rootTeamMember.rightChildUser.id, StructureType.TEAM)
      );
    }
  };

  return (
    <StructureArrow
      reverse
      disabled={!isRightArrowDownEnabled}
      onClick={goRighttDown}>
      <Icon
        color={
          isRightArrowDownEnabled
            ? color.colors.neutral50
            : color.colors.neutral100
        }>
        <IconStructureNavArrow />
      </Icon>
    </StructureArrow>
  );
};
